import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../api/dashboardApi';
import type { DashboardOverviewResponse } from '../api/dashboardApi';

/**
 * Hook to fetch dashboard overview data
 * Includes total houses, beds, utilization, earnings, and featured houses
 */
export const useDashboardOverview = () => {
  return useQuery<DashboardOverviewResponse>({
    queryKey: ['dashboard', 'overview'],
    queryFn: dashboardApi.getOverview,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
  });
};
